// src/events/completed_venue_bookings.js
import React from "react";
import { FiCheckCircle } from "react-icons/fi";

const COLORS = {
  primary: "#f20c53",
  secondary: "#fb6c33",
  text: "#0f172a",
  subtext: "#475569",
  border: "#e2e8f0",
  page: "#f5f6f8",
  card: "#ffffff",
};

export default function CompletedVenueBookings() {
  return (
    <div style={{ maxWidth: 1100, margin: "0 auto", display: "grid", gap: 16 }}>
      <section
        style={{
          background: COLORS.card,
          border: `1px solid ${COLORS.border}`,
          borderRadius: 14,
          boxShadow: "0 1px 2px rgba(0,0,0,.05)",
          padding: 16,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
          <div
            style={{
              width: 34,
              height: 34,
              display: "grid",
              placeItems: "center",
              borderRadius: 8,
              background: "#fff",
              border: `1px solid ${COLORS.border}`,
              color: COLORS.primary,
            }}
          >
            <FiCheckCircle />
          </div>
          <div style={{ fontWeight: 900, fontSize: 18, color: COLORS.text }}>
            Completed Bookings (Dummy)
          </div>
        </div>

        {/* Simple table-like list */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "160px 1fr 160px 140px",
            gap: 8,
            fontWeight: 800,
            color: COLORS.subtext,
            padding: "6px 8px",
          }}
        >
          <div>Booking ID</div>
          <div>Venue</div>
          <div>Date</div>
          <div>Amount (₹)</div>
        </div>
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            style={{
              display: "grid",
              gridTemplateColumns: "160px 1fr 160px 140px",
              gap: 8,
              border: `1px solid ${COLORS.border}`,
              borderRadius: 12,
              padding: "10px 12px",
              alignItems: "center",
              marginBottom: 8,
              background: "#fff",
            }}
          >
            <div>AA{9000 + i}</div>
            <div>Sample Venue {i}</div>
            <div>2025-09-{10 + i}</div>
            <div style={{ fontWeight: 900 }}>25,000</div>
          </div>
        ))}

        {/* NOTE: hook completed bookings query later */}
      </section>
    </div>
  );
}
